export default {
      id: "icon-quote-usage",
      viewBox: "0 0 72.527 55.813",
      url: __webpack_public_path__ + "icons.svg#icon-quote",
      toString: function () {
        return this.url;
      }
    }